import { render } from "./FormCompleteHeader.vue?vue&type=template&id=a1221634&scoped=true"
import script from "./FormCompleteHeader.vue?vue&type=script&lang=js"
export * from "./FormCompleteHeader.vue?vue&type=script&lang=js"

import "./FormCompleteHeader.vue?vue&type=style&index=0&id=a1221634&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a1221634"

export default script